import React, { Component, PropTypes } from 'react';
import ClassNames from 'classnames';

export default class TextField extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    type: PropTypes.string,
    autoFocus: PropTypes.bool,
    icon: PropTypes.string,
    inline: PropTypes.bool,
    hintText: PropTypes.string,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  };

  static defaultProps = {
    inline: false,
    type: 'text',
    autoFocus: false
  };

  change(e) {
    if (this.props.onChange) {
      this.props.onChange(e);
    }
  }

  render() {
    let {
      className,
      icon,
      defaultValue,
      hintText,
      autoFocus,
      inline,
      onChange,
      type,
      ...other
    } = this.props;
    if (icon) {
      icon = <i className={icon} />;
    }

    return (
      <div
        className={ClassNames('cio-textfield', className, {
          full: !inline,
          'has-icon': icon
        })}
      >
        {icon}
        <input
          placeholder={hintText}
          autoFocus={autoFocus}
          type={type}
          ref="input"
          defaultValue={defaultValue}
          onChange={this.change.bind(this)}
          {...other}
        />
      </div>
    );
  }

  getValue() {
    return React.findDOMNode(this.refs.input).value;
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Widgets/TextField.js